<template>
	<ul class="dependent-vendor-list" v-if="vendors.length">
		<!-- change to vendor prop instead of vendorTests once linked -->
		<li
			class="dependent-vendor-list__item"
			v-for="vendor in vendors"
			:key="vendor.id"
			:id="`${vendor.id}_form`"
			data-test-element="dependents-element"
		>
			<Button
				className="btn--inline-link dependent-vendor-list__item-link"
				:labelText="vendor.integratorName"
				:btnClick="() => navigateToVendorSettings(vendor.id)"
			/>
		</li>
	</ul>
</template>

<script>
import Button from '@/components/forms/button/button';

export default {
	name: 'DependentVendorsModalList',
	components: {
		Button
	},
	props: {
		vendors: {
			type: Array,
			default: () => []
		}
	},
	methods: {
		navigateToVendorSettings(id) {
			this.$router.push({
				name: 'vendors-settings',
				params: { id }
			});
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * 3P Vendor Manager - Vendor card - Dependent 3P Vendors Modal List
    * Can use SCSS variables = TRUE
*/

.dependent-vendor-list {
	overflow-y: auto;
	margin-top: $gutter-xl;
	max-height: calc(100vh - 260px);
	@include scrollbar;

	@include mq($from: md) {
		max-height: calc(87vh - 320px);
	}

	&__item {
		&:not(:first-child) {
			margin-top: $gutter-lg;
		}

		&-link {
			max-width: calc(100% - 12px);
			@include ellipsis;
		}
	}
}
</style>
